import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult, IsApplicationSolar } from '../rules';
import IsTaxEquityPartnering from '../rules/IsTaxEquityPartnering';

class MonetizeTaxCreditCheckRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (!IsApplicationSolar.evaluate(data)) return RulesetResult.HIDDEN;
    if (IsTaxEquityPartnering.evaluate(data)) return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}
export default new MonetizeTaxCreditCheckRuleset();
